/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchClientType } from './SearchClientType';
import {
    SearchClientTypeFromJSON,
    SearchClientTypeFromJSONTyped,
    SearchClientTypeToJSON,
} from './SearchClientType';

/**
 * 
 * @export
 * @interface SearchResult
 */
export interface SearchResult {
    /**
     * 
     * @type {number}
     * @memberof SearchResult
     */
    dateAdded: number;
    /**
     * Optional text to display in the secondary CTA button of the search result card. If this is not defined, the button
     * will not appear on the card.
     * @type {string}
     * @memberof SearchResult
     */
    buttonText?: string | null;
    /**
     * Freeform object that will be passed to client apps when a search result is selected. You should include any data
     * needed by your apps to handle navigating to a selected search result or secondary CTA click in here.
     * @type {{ [key: string]: object; }}
     * @memberof SearchResult
     */
    metadata: { [key: string]: object; };
    /**
     * Additional search terms to index for this result that will not be visible on the search results card.
     * @type {Array<string>}
     * @memberof SearchResult
     */
    additionalSearchMatches: Array<string>;
    /**
     * Optional preview text that will appear on the subtitle of the search result card e.g. "Jackpot $10,000,000".
     * 
     * This field will be indexed and searchable.
     * @type {string}
     * @memberof SearchResult
     */
    previewText?: string | null;
    /**
     * Array of client types that this search result can appear on. You can use this to e.g. show a specific result only
     * to Android devices.
     * @type {Array<SearchClientType>}
     * @memberof SearchResult
     */
    supportedClients: Array<SearchClientType>;
    /**
     * The type of the result as it will appear in the subtitle of the search result card, e.g. "Game" or "Article".
     * Types are user defined in this import, but care should be taken to limit the types to an appropriate number of
     * shared categories.
     * @type {string}
     * @memberof SearchResult
     */
    resultType: string;
    /**
     * Optional ull url to a publicly hosted image to display on the search result card. The image should be a 3:2 aspect
     * ratio and in a standard, widely supported image format like PNG, GIF, JPEG, etc. If the image is omitted a
     * placeholder will be used on the search result card.
     * @type {string}
     * @memberof SearchResult
     */
    imageUrl?: string;
    /**
     * Name of the search result as it will appear on the title of the search result card. e.g. "Mega Millions"
     * 
     * This field will be indexed and searchable
     * @type {string}
     * @memberof SearchResult
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SearchResult
     */
    dateLastModified: number;
}

/**
 * Check if a given object implements the SearchResult interface.
 */
export function instanceOfSearchResult(value: object): value is SearchResult {
    if (!('dateAdded' in value) || value['dateAdded'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    if (!('additionalSearchMatches' in value) || value['additionalSearchMatches'] === undefined) return false;
    if (!('supportedClients' in value) || value['supportedClients'] === undefined) return false;
    if (!('resultType' in value) || value['resultType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('dateLastModified' in value) || value['dateLastModified'] === undefined) return false;
    return true;
}

export function SearchResultFromJSON(json: any): SearchResult {
    return SearchResultFromJSONTyped(json, false);
}

export function SearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'dateAdded': json['dateAdded'],
        'buttonText': json['buttonText'] == null ? undefined : json['buttonText'],
        'metadata': json['metadata'],
        'additionalSearchMatches': json['additionalSearchMatches'],
        'previewText': json['previewText'] == null ? undefined : json['previewText'],
        'supportedClients': ((json['supportedClients'] as Array<any>).map(SearchClientTypeFromJSON)),
        'resultType': json['resultType'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'name': json['name'],
        'id': json['id'],
        'dateLastModified': json['dateLastModified'],
    };
}

export function SearchResultToJSON(value?: SearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dateAdded': value['dateAdded'],
        'buttonText': value['buttonText'],
        'metadata': value['metadata'],
        'additionalSearchMatches': value['additionalSearchMatches'],
        'previewText': value['previewText'],
        'supportedClients': ((value['supportedClients'] as Array<any>).map(SearchClientTypeToJSON)),
        'resultType': value['resultType'],
        'imageUrl': value['imageUrl'],
        'name': value['name'],
        'id': value['id'],
        'dateLastModified': value['dateLastModified'],
    };
}

